 
<template>
    <div id="navigatorDataDashboard">

        <NavbarComponent :loadingStatus="loading">Navigator Zeroes Deleter</NavbarComponent>
  <div class="alert alert-info" role="alert">
          Step 1. Select meters from tree or search. <br>
          Step 2. Click the "Get Meter Data" Button. This will get the readings and show all zero readings. <br>
          Step 3. Please inspect the zero reeadings to make sure they are what you want to delete. <br>
          Step 4. Click the "Delete Zeroes" Button. Successfully deleted readings will be removed from the list. 
        </div>
        <section class="section">
        

        
            <div class="columns">
                <div class="column is-one-quarter">
                    <!-- Left side Tiles -->

                    <!-- Search Tree Tile -->
                    <div class="box">
                        <!-- search -->
                        <div class="field has-addons">
                            <div class="control">
                                <input class="input is-small" type="text" v-on:keyup.enter="searchNavigator" v-model="searchString" style="width:15em">
                            </div>
                            <div class="control">
                                <a class="button is-small is-primary" @click="searchNavigator">
                                    Search {{this.$store.getters.lastSelectedTreeName}}
                                </a>
                            </div>
                        </div>

                        <div class="field has-addons">
                            <div class="control">
                                <input class="input is-small" type="text" v-model="searchFilter" placeholder="Filter with *"
                                    style="width:15em">
                            </div>
                            <div class="control">
                                <a class="button is-small is-primary" @click="addSearchMeters">
                                    Add All Meters
                                </a>
                            </div>
                        </div>


                        <div v-for="item in searchResultFiltered">
                            <SearchResult :item="item"></SearchResult>
                        </div>
                    </div>

                    <!-- Meter Tree Tile -->
                    <div class="box">
                        <!-- dimension select -->
                        <div class="field has-addons">
                            <p class="control">
                                <p class="button is-primary is-small is-secondary primary"> Dimension </p>
                                <p>
                                    <p class="control">
                                        <div class="select is-small">
                                            <select v-model="selectedUserDimension">
                                                <option v-for="(dimension,index) in userDimensions" :value="dimension.id"
                                                    v-bind:selected="index===0">{{dimension.name}}</option>
                                            </select>
                                        </div>

                        </div>


                        <!-- Meter tree -->

                        <treemenu :nodes="this.$store.getters.tree.nodes" :key="this.$store.getters.tree.id" :depth="0"
                            :name="this.$store.getters.tree.name" :id="this.$store.getters.tree.id" :type="this.$store.getters.tree.type"
                            :expandable="this.$store.getters.tree.expandable"></treemenu>
                    </div>
                </div>



                <!-- Right side Tiles -->
                <div class="column">
                    <!-- horizontal level for dates-->
                    <div class="box">

                        <div class="field is-grouped is-grouped-multiline">
                            <div class="field extra-space">
                                <label class="label">Date Time Range</label>
                                <p class="control">
                                    <div class="select is-small" style="margin-top:-8px;">
                                        <select v-model="selectedTimeRange">
                                            <option value="Yesterday" selected>Yesterday</option>
                                            <option value="Last 24 hours">Last 24 hours</option>
                                            <option value="Last 7 days">Last 7 days</option>
                                            <option value="Last 14 days">Last 14 days</option>
                                            <option value="Last 30 days">Last 30 days</option>
                                            <option value="Last 3 months">Last 3 months</option>
                                            <option value="Last year">Last year</option>
                                            <option value="year to date">Year to Date</option>
                                        </select>
                                    </div>
                            </div>
                            </p>

                            <div class="field extra-space">
                                <p class="control">
                                    <label class="label">Start Time: (DD.MM.YYYY HH:mm:ss in local time) </label>
                                    <input class="input is-small shift-up" type='text' v-model="localStartTimeStamp">
                                </p>
                            </div>
                            <div class="field extra-space">
                                <p class="control">
                                    <label class="label"> End Time: (DD.MM.YYYY HH:mm:ss in local time) </label>
                                    <input class="input is-small shift-up" type='text' v-model="localEndTimeStamp">
                                </p>
                            </div>
                         

                        </div>






                        <!-- selected meters-->
                        <!-- Meters: <input class="input is-small" type='text' v-model="meterDataIdArray"></input>-->
                        <p><b>Meters to Delete Zeroes:</b></p>
                        <div v-for="meter in this.$store.getters.meterDataIdNameArray">
                            <div class="meter-list-graph-item " v-if="meter.loaded">
                                <font color="green">{{meter.name}} {{meter.id}} {{meter.unit}} </font>
                            </div>
                            <div class="meter-list-graph-item " v-else>
                                {{meter.name}} {{meter.id}} {{meter.unit}}
                            </div>
                        </div>

                        <br>

                        <!-- horizontal level for control buttons-->
                        <div class="field is-grouped is-grouped-multiline">
                            <p class="control">
                                <button class="button is-primary" @click="getMeterDataButton">Get Meter Data</button>
                            </p>
                            <p class="control">
                                <button class="button is-warning" @click="clearMeters">Clear Meters</button>
                            </p>
                            <p class="control">
                                <button class="button is-dark" @click="deleteZeroes">Delete Zeroes</button>
                            </p>
                        


                        </div>
                    </div>


                    <div class="box">
                    
                    <p>Deleted {{deletedReadingsCount}} of {{totalReadings}} readings.</p>
                    
                    <br>
                    
                    <b> Zero Readings </b>
                    <br>
                
                       <div v-for="reading in zeroesData">
                            <li>{{reading}}</li>
                        </div>
               
                    
                    
                        <!-- charts -->
                        <div v-for="chart in charts">
                            <ReactiveChart :chart="chart"></ReactiveChart>
                        </div>
                    </div>

                </div>
            </div>




        </section>

        <!-- end of app -->
    </div>
</template>

<script>

import treemenu from '@/components/TreeMenu';
import LoadingComponent from '@/components/LoadingComponent';
import ReactiveChart from '@/components/ReactiveChart';
import SearchResult from '@/components/SearchResult';
import MeterComponent from '@/components/MeterComponent';
import LogoutComponent from '@/components/LogoutComponent';
import moment from 'moment';
import _ from 'lodash';
import saveAs from 'file-saver';
import NavbarComponent from '@/components/NavbarComponent.vue'

//VUE ROOT remove password when ready
export default {
	name: 'navigatorDataDashboard',
    components: {treemenu, LoadingComponent, SearchResult, ReactiveChart, MeterComponent, LogoutComponent, NavbarComponent},
        // Empty data array to initialise this.$axios data into
        data: function() { return { 
            devices: [],
        	currentTime: '',
            proxyurl: this.$store.getters.proxyurl,
        	filterLocation: 'NSW',
        	username: this.$store.getters.navigatorUsername,
        	password: this.$store.getters.navigatorPassword, //remove password when ready!
            userId: this.$store.getters.navigatorUserId,
            loggedInStatus: false,
            lastSelectedTreeId: '',
            lastSelectedTreeName: '',
            userDimensions: [],
            selectedUserDimension:'16', //default to technical for now
        	tree: {id:'450867',name:'Siemens Australia',nodes:[],type:'NODE',expandable:true},
            treeShowChildrenArray:[],
        	nodeRetrievedList:[],
        	loading: false,
            meterData:[],
            meterDataIdArray: [],
            meterDataIdNameArray:[],                
            localStartTimeStamp: moment().subtract(7,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss"),
            localEndTimeStamp:  moment().startOf('day').format("DD.MM.YYYY HH:mm:ss"),
            selectedTimeRange: 'Last 7 days',
            //utcStartTimeStamp:'10.10.2018 00:00:00',
            //utcEndTimeStamp:'10.01.2019 02:00:00',
        	charts: [],
            includeRangeSlider: true,
            autoGraphData: true,
            searchString: 'Search in highlighted Node',
            searchFilter: '',
            searchResult:[],
            zeroesData: [],
            deletedReadingsCount: 0,
            totalReadings: 0,
            iterationsStep: 10,
            
        }
    },
    computed: {

        	filteredDevices(){
                    return this.devices.filter(device => device.location.includes(this.filterLocation)); //filter all tasks not completed
                },
                
            //convert the local timestamps to utc timestamps to be used by Navigator API calls (all in UTC) the data is then later transformed back to local time in the graphs   
            utcStartTimeStamp(){
                return moment(this.localStartTimeStamp,"DD.MM.YYYY HH:mm:ss").utc().format("DD.MM.YYYY HH:mm:ss");
            },
            utcEndTimeStamp(){
                return moment(this.localEndTimeStamp,"DD.MM.YYYY HH:mm:ss").utc().format("DD.MM.YYYY HH:mm:ss");
            },
            searchResultFiltered(){ //search Result Filter whenever new searchResult or searchFilter changes
                let filteredList = [];
                
                //create array of filter terms split by *
                let filterWordsArray = this.searchFilter.split('*');
                
                //If list is nothing, then do nothing
                if(this.searchResult.list == null){
                    return null;
                }else{
                
                //Otherwise get all the meter objects          
                this.searchResult.list.forEach((item)=>{
                    if(item.treeObjectType == 'METER'){
                        filteredList.push(item);
                    }
                });
                
                //for each filter word
                filterWordsArray.forEach((word)=>{
                //update the filteredList to contain only meters with names that include the filter word    
                filteredList = filteredList.filter(item=>item.name.toUpperCase().includes(word.toUpperCase()));
                });
                
                return filteredList;
                }
            },
           
            },
            methods: {
            	
        //Updates Current Time Method
        updateCurrentTime() {
        	this.currentTime = moment().format('LTS')
        },
        
        changeTitle() {
        	this.charts[0].layout.title='changed';
        },
        
        //Add data to graph
        addData: function() {
        },
        
        //loginto Navigator check and get userId
        loginNavigator(){
             this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/users/current"
             
             //return for the async await
              return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                
                this.userId = response.data.id;
                this.loggedInStatus = true;
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loggedInStatus = false;
                        this.loading=false;

                }); 
        },
        getUserDimensions(){
            this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/users/" + this.userId.toString() + "/dimensions";
             
             //return for the async await
                 return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                response.data.forEach((dimension)=>{
                this.userDimensions.push({id: dimension.id, name: dimension.name});
                });
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;
                });
                
        },
        //update metertree root with user selected dimension
        updateMeterTreeRoot(){
             this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.userId.toString() + "/dimension/" + this.selectedUserDimension.toString() + '/root';
             
             //return for the async await
                 return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {

                //base node of tree equals the response data
                this.$store.commit('changetree',{id: response.data.id, name: response.data.name, nodes: [], type:response.data.treeObjectType, expandable: response.data.expandable });
                this.$store.commit('changelastSelectedTreeId',response.data.id);
                this.$store.commit('changelastSelectedTreeName',response.data.name);
                //empty node retreived list
                this.$store.commit('changenodeRetrievedList',[]);
                this.$store.commit('changetreeShowChildrenArray',[]); //empty tree as well
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;
                });
                
        },
        
        //initial load method, with async methods so each function waits for the previous one to finish
        async initialLoad() {
              await this.loginNavigator();
              await this.getUserDimensions();
              await this.updateMeterTreeRoot();
        },
        
        //search Navigator for meters/nodes with the last selected Node
        searchNavigator() {

             this.loading=true;
            //Navigator devices API url
            const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.$store.getters.navigatorUserId.toString() +"/node/" + this.$store.getters.lastSelectedTreeId.toString() + "/search?searchstring=" + this.searchString.toString();

            this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                
            	this.searchResult = response.data;
                 this.loading=false;
        }).catch(error => { 
        this.loading=false;
                        console.log(error)             
                        });  
        
        },
        getIntialNodes(meterId){
        	
        	this.showChildren = !this.showChildren;
            //Navigator devices API url
            //requires userId, starttime and endtime in unix (with milliseconds)
            //using CORS proxy to bypass the No Access-Control-Allow-Origin header in server
            //see https://gist.github.com/jesperorb/6ca596217c8dfba237744966c2b5ab1e for more details on how to handle CORs client-side
            var url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.userId.toString() + "/node/" + meterId + "/children";              
            
            this.$axios({ method: 'get',
            	url: url,
            	headers: {
            		'Accept': 'application/json',
            		'Content-Type': 'x-www-form-urlencoded',
            	},

            }).then(response => {                
            //set this Vue instance devices data with the formatted reponse data
            
            var step;
            //iterate through whole data array
            for (step = 0; step < response.data.length; step++) {
            	this.tree.nodes.push({name:response.data[step].name, id:response.data[step].id, nodes:[]});
            	
            }
        })
        },
        addSearchMeters(){

                 let meterDataIdArray = this.$store.getters.meterDataIdArray;
            let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
            this.searchResultFiltered.forEach((meter)=>{
       
                if(meterDataIdArray.includes(meter.id.split('-')[1]) === false){    //check if meter is not already in the meter data id array 
            meterDataIdArray.push(meter.id.split('-')[1]);
            meterDataIdNameArray.push({id: meter.id.split('-')[1], name: meter.name, loaded:false, unit: ''} );
            
                }
            });
            this.$store.commit('changemeterDataIdArray',meterDataIdArray);
            this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArray);    
                
        },
        clearMeters(){
            this.$store.commit('changemeterDataIdArray',[]);
            this.$store.commit('changemeterDataIdNameArray',[]);
        },
        
        setDates(range){
            
            if(range.toUpperCase() === "LAST 24 HOURS"){
               this.localStartTimeStamp = moment().subtract(1, "days").format("DD.MM.YYYY HH:mm:ss");
               this.localEndTimeStamp = moment().format("DD.MM.YYYY HH:mm:ss");   
            }
            else if(range.toUpperCase() === "YESTERDAY"){
                this.localStartTimeStamp = moment().subtract(1,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            } 
            else if(range.toUpperCase() === "LAST 7 DAYS"){
                 this.localStartTimeStamp = moment().subtract(7,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            }
            else if(range.toUpperCase() === "LAST 14 DAYS"){
                 this.localStartTimeStamp = moment().subtract(14,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            }             
            else if(range.toUpperCase() === "LAST 30 DAYS"){
                this.localStartTimeStamp = moment().subtract(30,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            } 
            else if(range.toUpperCase() === "LAST 3 MONTHS"){  
                this.localStartTimeStamp = moment().subtract(3,'months').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");               
            } 
            else if(range.toUpperCase() === "LAST YEAR"){
                this.localStartTimeStamp = moment().subtract(1,'years').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");  
            }
            else if(range.toUpperCase() === "YEAR TO DATE"){
                this.localStartTimeStamp = moment().startOf('year').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");  
               
            }
        },
           
          async getAsyncMeterData(){
              
            //reset the loaded meter data flags  
            let meterDataIdNameArrayUnloaded =  this.$store.getters.meterDataIdNameArray
            meterDataIdNameArrayUnloaded.forEach((meter)=>{
               meter.loaded = false;
            });                
            this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArrayUnloaded);
              
            this.meterData = []; //reset the meterData stored
            this.loading = true; //set loading flag 
            
            //intialise variables.
            var meterIDsArray;
            var meterDataCountTotal;
            var readingPagesTotal;
            var meterCountTotal;
            var i;
            var readingIndex;
            var pageNumber;
            var meter;
            var index;
            var meterIndex;
            var url;
            var meterDataTemplate;
       
            
            
            	
            //GET the meter Data using the meter ID. Then do a get request for meter reading with start and time to get reading count,
            //generate all the necessary urls because each response from a get request is limited to only 1000 readings, 
            //do all the get requests simultaneously to get all the readings, then push them into the data array. 
            
            
            meterIDsArray = this.$store.getters.meterDataIdArray.toString().split(','); //turn the string of meterIds into an array. 
            //for (index = 0; index < meterIDsArray.length; index++){   //async call inside for loop doesn't work well, index always last value
            await Promise.all(meterIDsArray.map(async (meter, index) =>{
                    
                        let meterInfoUrl =  this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString();  
                        
                        await this.$axios({ method: 'get',url: meterInfoUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},
                        }).then(async response => {   
                        
 
                        response.data["data"]=[];
                        //this.meterData.push(response.data);
                        
                        
                       //THIS meter data template is going to be filled with the meter data, passing down through each of the this.$axios promises
                        //then finally pushed to the this.meterData array. This is to stop race conditions when pushing the data straight into the this.meterDAta array 
                        //and trying to use index to put the data in the right place with all the async calls going on. Seems to be working well
                        let meterDataTemplate = response.data;

                        let meterReadingsUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString() +'/readings?utcStartTimestamp='+this.utcStartTimeStamp.toString() + '&utcEndTimestamp=' + this.utcEndTimeStamp.toString(); 
                        
                        //variables can be passed into the next promise .then by using a promise.all and a array
                        return await Promise.all([this.$axios({ method: 'get',url: meterReadingsUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}), meterDataTemplate]);
                        
                        }).then(async([response2, meterDataTemplate]) => {
                         response2.data.totalCount;
                        readingPagesTotal = Math.ceil((parseInt(response2.data.totalCount)/1000)); //divide and round up
                        console.log("Total pages to retrieve: " + readingPagesTotal);
 

                               
                                  //construct array of urls
                        let urlArray = [];
   
                        let meterReadingMultipleUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString() +'/readings?utcStartTimestamp='+this.utcStartTimeStamp.toString() + '&utcEndTimestamp=' + this.utcEndTimeStamp.toString(); 
                          for (pageNumber = 0; pageNumber < readingPagesTotal; pageNumber++){
                            urlArray.push(meterReadingMultipleUrl+"&limit=1000&start=" + (pageNumber*1000).toString());
  
                          }
                          
                           
                    let promiseArray = urlArray.map(url => this.$axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));
                            promiseArray.push(meterDataTemplate);
                           //do all get request at same time for efficiency
                            return await this.$axios.all(promiseArray);   
                               
                        }).then(async(response3) => {
                 
                        meterDataTemplate = response3.pop();
     
                        
                        //check if response 3 is empty (means no data exists for meter)
                        if(response3.length === 0){ 
                        meterDataTemplate.data.push({unit:'No Data'}); //push one reading with a no data unit for graphs to display
                        }
        
                        
                                 //push all meter readings into the meterData[index].data array
                                 response3.forEach((pageResponse, pageIndex)=>{
                                     pageResponse.data.items.forEach((reading, readingIndex)=>{
                                        //this.meterData[index].data.push(reading);
                                       meterDataTemplate.data.push(reading);
                                     });
                                 });
                                 
                             //push the meter Data in the meterData template to the this.meterData (we don't care the order of the meters so we don't worry about race conditions)    
                            this.meterData.push(meterDataTemplate);
                            
                            
                            return await Promise.all([meterDataTemplate]);
                        }).then(async (response4)=>{
                            
                          //response4[0] is meterDataTempalte
                          let meterDataIdNameArrayUpdate = this.$store.getters.meterDataIdNameArray;
                          index = meterDataIdNameArrayUpdate.findIndex(x => x.id==response4[0].id);
                          meterDataIdNameArrayUpdate[index].unit = response4[0].data[0].unit;
                          meterDataIdNameArrayUpdate[index].loaded = true;
                          
                          this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArrayUpdate);
                          console.log("Finished Loading Meter: " + response4[0].name);
                          
                          return Promise.resolve('ok') ;
                          
                        
                        }).catch(error => { 
                        console.log(error)             
                        });    
            })
            );    
            this.loading=false;
            
            return await console.log("Done getting Meter Data!");
                  
        },   
        
        async getZeroesData(){
        this.loading=true;
        this.zeroesData = [];   
        let zeroesDataArray = [];
        this.meterData.forEach((meter)=>{
        meter.data.forEach((record)=>{
            if (parseFloat(record.value) == parseFloat(0.0)){
            zeroesDataArray.push({localBrowserTime: moment.utc(record.utcRectime).local().format('YYYY-MM-DD HH:mm:ss'), value: record.value, utcRectime: moment.utc(record.utcRectime).format('YYYY-MM-DD HH:mm:ss'), unit:record.unit, meterId: meter.id, meterName: meter.name})
            };
            })
        });
        
       
        this.zeroesData = _.orderBy(zeroesDataArray, ['meterid', 'utcRectime'], 'asc');
         this.totalReadings = this.zeroesData.length;
        this.loading=false;
        return console.log("Got Zeroes Data Array");
    },
    
   async  deleteZeroes(){
   
     
      var zeroesDataLength =  this.zeroesData.length;
   
   this.totalReadings = this.zeroesData.length;
  
   this.deletedReadingsCount = 0;
    
    this.loading=true;
    
    //get all urls to delete readings, but do it in batches
    
    for (var i = 0; i< zeroesDataLength/this.iterationsStep; i++){
    
            let promiseArray = [];
            await this.zeroesData.slice(0,this.iterationsStep).forEach((reading)=>{
            let formattedUtcRecTime = moment(reading.utcRectime, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
            let deleteUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/"+reading.meterId+"/readings/"+formattedUtcRecTime;
            promiseArray.push(this.$axios({method: 'delete',url: deleteUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));
            })

            //this.$axios delete all the readings
             await this.$axios.all(promiseArray)
                     .then((responseArray) => {
                     
                     //if reponse status returns 204 then remove from zeroesData Array to show it has been deleted
                     
                     let successfulDeletedReadingsIndices = [];

                     
                                 responseArray.forEach((response,index)=>{
                                 if (response.status == 204){
                                 successfulDeletedReadingsIndices.push(index);
                                  this.deletedReadingsCount += 1
                                 };
                                 });
                     
                                 successfulDeletedReadingsIndices.reverse().forEach((indexToDelete)=>{
                                this.zeroesData.splice(indexToDelete,1);
                                 });
                     
                     });
 
    };
 
 this.loading=false;
 return console.log("Done Deleting Zeroes")

 
    },
        
        //Method to get Meter Data and then after all the meter data is saved then graph if the autoGraphData checkbox is true
        async getMeterDataButton(){
            console.log("Time to get Data!");
            await this.getAsyncMeterData();
            await this.getZeroesData();
  
        },
              
 
        //function to get all the meter data readings between start and end date for meters in the ID list. 
        getMeterData(){
            this.meterData = []; //reset the meterData stored
            this.loading = true; //set loading flag 
            
            //reset the loaded meter data flags  
            this.$store.getters.meterDataIdNameArray.forEach((meter)=>{
                meter.loaded = false;
            });  
            
            //intialise variables.
            var meterIDsArray;
            var meterDataCountTotal;
            var readingPagesTotal;
            var meterCountTotal;
            var i;
            var readingIndex;
            var pageNumber;
            var meter;
            var index;
            var meterIndex;
            var url;   
            
            
            	
            //GET the meter Data using the meter ID. Then do a get request for meter reading with start and time to get reading count,
            //generate all the necessary urls because each response from a get request is limited to only 1000 readings, 
            //do all the get requests simultaneously to get all the readings, then push them into the data array. 
            
            
            meterIDsArray = this.$store.getters.meterDataIdArray.toString().split(','); //turn the string of meterIds into an array. 
            //for (index = 0; index < meterIDsArray.length; index++){   //async call inside for loop doesn't work well, index always last value
            meterIDsArray.forEach((meter, index) =>{
                    console.log(meter);
                        let meterInfoUrl =  this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString();  
                        
                        this.$axios({ method: 'get',url: meterInfoUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},
                        }).then(response => {   
                        
 
                        response.data["data"]=[];
                        //this.meterData.push(response.data);
                        
                        
                       //THIS meter data template is going to be filled with the meter data, passing down through each of the this.$axios promises
                        //then finally pushed to the this.meterData array. This is to stop race conditions when pushing the data straight into the this.meterDAta array 
                        //and trying to use index to put the data in the right place with all the async calls going on. Seems to be working well
                        var meterDataTemplate = response.data;

                        let meterReadingsUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString() +'/readings?utcStartTimestamp='+this.utcStartTimeStamp.toString() + '&utcEndTimestamp=' + this.utcEndTimeStamp.toString(); 
                        
                        //variables can be passed into the next promise .then by using a promise.all and a array
                        return Promise.all([this.$axios({ method: 'get',url: meterReadingsUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}), meterDataTemplate]);
                        
                        }).then(([response2, meterDataTemplate]) => {
                         response2.data.totalCount;
                        readingPagesTotal = Math.ceil((parseInt(response2.data.totalCount)/1000)); //divide and round up
                        console.log("Total pages to retrieve: " + readingPagesTotal);
 

                               
                                  //construct array of urls
                        let urlArray = [];
   
                        let meterReadingMultipleUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString() +'/readings?utcStartTimestamp='+this.utcStartTimeStamp.toString() + '&utcEndTimestamp=' + this.utcEndTimeStamp.toString(); 
                          for (pageNumber = 0; pageNumber < readingPagesTotal; pageNumber++){
                            urlArray.push(meterReadingMultipleUrl+"&limit=1000&start=" + (pageNumber*1000).toString());
  
                          }
                          
                           
                    let promiseArray = urlArray.map(url => this.$axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));
                            promiseArray.push(meterDataTemplate);
                           //do all get request at same time for efficiency
                            return this.$axios.all(promiseArray);   
                               
                        }).then((response3) => {
                 
                        meterDataTemplate = response3.pop();
     
                        
                        //check if response 3 is empty (means no data exists for meter)
                        if(response3.length === 0){ 
                        meterDataTemplate.data.push({unit:'No Data'}); //push one reading with a no data unit for graphs to display
                        }
        
                        
                                 //push all meter readings into the meterData[index].data array
                                 response3.forEach((pageResponse, pageIndex)=>{
                                     pageResponse.data.items.forEach((reading, readingIndex)=>{
                                        //this.meterData[index].data.push(reading);
                                       meterDataTemplate.data.push(reading);
                                     });
                                 });
                                 
                             //push the meter Data in the meterData template to the this.meterData (we don't care the order of the meters so we don't worry about race conditions)    
                            this.meterData.push(meterDataTemplate);
                            
                            
                            return Promise.all([meterDataTemplate]);
                        }).then((response4)=>{
                            
                          //response4[0] is meterDataTempalte
                          
                          let meterDataIdNameArrayUpdate = this.$store.getters.meterDataIdNameArray;
                          index = meterDataIdNameArrayUpdate.findIndex(x => x.id==response4[0].id);
                          meterDataIdNameArrayUpdate[index].unit = response4[0].data[0].unit;
                          meterDataIdNameArrayUpdate[index].loaded = true;
                          
                          this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArrayUpdate);
                            this.loading=false;
                          return console.log("Finished Loading Meter: " + response4[0].name);
                          
                        }).catch(error => {
                          this.loading=false;
                        console.log(error)             
                        });    
            });    
                       
        },
        
        //This function grabs whatsever is in the meterData and transforms it in the the charts data field
        graphAllMeterData(){
            this.loading = true;
            
            //Variation 1 is to put all on same graph
            //empty the charts data field
            var chartsGraphData=[];
            var chartTraces = [];
            var chartlayout = {};
            var chartLayout = {};

            this.meterData.forEach((meter,index)=>{                
                var chartUuid = 'chart'+index.toString(); //if trying to change div without an existing div then will throw null error for DOM    
                var chartLayout = {};
                var chartTitle = '';
                var xaxisTitle = '';
                var yaxisTitle = '';
                var xaxisRangeMin = moment.utc(this.utcStartTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                var xaxisRangeMax = moment.utc(this.utcEndTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                var xaxisLayout;
                if (this.includeRangeSlider === true){
                xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax], rangeselector: {buttons: [
                    { count: 1,label: '1d',step: 'day',stepmode: 'backward'},
                    { count: 7,label: '1w',step: 'day',stepmode: 'backward'},
                    { count: 1,label: '1m',step: 'month',stepmode: 'backward'},
                    { count: 6,label: '6m',step: 'month',stepmode: 'backward'},
                    {step: 'all'}
                        ]},
                    rangeslider: {autorange: true, visible:true},
                    }
                } else {xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax]};
                }
                
                
                chartLayout = {title: chartTitle, xaxis: xaxisLayout, yaxis: {title:yaxisTitle}, legend: {orientation: 'h',xanchor:"center", y:1.3, x:0.5}, showlegend: true};

                let chartTraceName = meter.name + " ("+meter.data[0].unit+")";
                
                let chartTraceXArray = [];
                meter.data.forEach((reading)=>{
                    //convert into local browser time from UTC before putting into X array
                    //original utc format in 11/3/2018 03:30:00 PM
                    //let utcDateTime = moment(reading).format('M/D/YYYY hh:MM:SS a');
    
                    chartTraceXArray.push(moment.utc(reading.utcRectime).local().toDate());
                });
                
                
                let chartTraceYArray = [];
                    meter.data.forEach((reading)=>{
                    chartTraceYArray.push(reading.value);
                });

                var chartLineColour = '#17BECF'
                let chartTrace = {type: "scatter", mode: "lines", name: chartTraceName, x: chartTraceXArray, y: chartTraceYArray};
                //line: {color: '#17BECF'}
                
                chartTraces.push(chartTrace);
            });
            chartUuid = 'chart0'; //because there will be only be one chart
            this.loading = false;   
            chartsGraphData.push({uuid: chartUuid, traces: chartTraces, layout: chartLayout}); 
            this.charts = chartsGraphData;
            console.log(chartsGraphData);     

                
        },
        
        graphSplitMeterData(){
            this.loading = true;
            
            //Variation 2 is to split graphs by units
            //empty the charts data field
            var chartsGraphData=[];
            var chartTraces = [];
            var unitsArray = [];
            var chartCounter = 0;
            var chartLayout = {};

            this.meterData.forEach((meter,index)=>{
                let chartUnit = meter.data[0].unit;
              
                
                var chartUuid = 'chart'+index.toString(); //if trying to change div without an existing div then will throw null error for DOM
                
                var chartlayout = {};
                var chartTitle = '';
                var xaxisTitle = '';
                var yaxisTitle = '';
                  var xaxisRangeMin = moment.utc(this.utcStartTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                var xaxisRangeMax = moment.utc(this.utcEndTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                
                var xaxisLayout;
                if (this.includeRangeSlider === true){
                xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax], rangeselector: {buttons: [
                    { count: 1,label: '1d',step: 'day',stepmode: 'backward'},
                    { count: 7,label: '1w',step: 'day',stepmode: 'backward'},
                    { count: 1,label: '1m',step: 'month',stepmode: 'backward'},
                    { count: 6,label: '6m',step: 'month',stepmode: 'backward'},
                    {step: 'all'}
                        ]},
                    rangeslider: {autorange: true, visible:true},
                    }
                } else {xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax]};
                }
                
                
                chartLayout = {title: chartTitle, xaxis: xaxisLayout, yaxis: {title:yaxisTitle}, legend: {orientation: 'h',xanchor:"center", y:1.2, x:0.5}, showlegend: true};
                
                var chartTraceName = meter.name + " ("+meter.data[0].unit+")";
                
                let chartTraceXArray = [];
                meter.data.forEach((reading)=>{
                    //convert into local browser time from UTC before putting into X array
                    //original utc format in 11/3/2018 03:30:00 PM
                    //let utcDateTime = moment(reading).format('M/D/YYYY hh:MM:SS a');
                    chartTraceXArray.push(moment.utc(reading.utcRectime).local().toDate());
                });
                
                
                let chartTraceYArray = [];
                    meter.data.forEach((reading)=>{
                    chartTraceYArray.push(reading.value);      
                    
                });     
               
               //get the index of this.charts where to put data based on unit
                               
                    
                  //check if unit of meter is in the unit array otherwise add to unit array and push a template graph
                if(unitsArray.includes(chartUnit)== false){
                    unitsArray.push(chartUnit);
                    
                chartUuid = 'chart'+chartCounter.toString();
                    chartCounter++;
                chartsGraphData.push({uuid: chartUuid, traces: [], layout: chartLayout})    
                    
                }
                
               let graphIndex = unitsArray.findIndex(x=>x==chartUnit);    
                      
                
                var chartLineColour = '#17BECF'
                let chartTrace = {type: "scatter", mode: "lines", name: chartTraceName, x: chartTraceXArray, y: chartTraceYArray};
                //line: {color: '#17BECF'}
                
                //push the chart data tract into the graph with the corresponding index
                chartsGraphData[graphIndex].traces.push(chartTrace);

            });
 
            this.charts = chartsGraphData;
            console.log(chartsGraphData);    
             this.loading = false;       
        },
        
               
        //Variation 4 is to split graphs by nodes. uses the split graph function by changes the sorting from unit to id.split('-')[0]
        //empty the charts data field
        graphSplitNodeData(){
            this.loading = true;
     
            var chartsGraphData=[];
            var chartTraces = [];
            var unitsArray = [];
            var chartCounter = 0;
            var chartLayout = {};

            this.meterData.forEach((meter,index)=>{
                let chartUnit = meter.parentNodeId;
              
                
                var chartUuid = 'chart'+index.toString(); //if trying to change div without an existing div then will throw null error for DOM
                
                var chartlayout = {};
                var chartTitle = chartUnit.toString(); //chartUnit.toString(); or search api for the node id name 
                var xaxisTitle = '';
                var yaxisTitle = '';
                  var xaxisRangeMin = moment.utc(this.utcStartTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                var xaxisRangeMax = moment.utc(this.utcEndTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                
                var xaxisLayout;
                if (this.includeRangeSlider === true){
                xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax], rangeselector: {buttons: [
                    { count: 1,label: '1d',step: 'day',stepmode: 'backward'},
                    { count: 7,label: '1w',step: 'day',stepmode: 'backward'},
                    { count: 1,label: '1m',step: 'month',stepmode: 'backward'},
                    { count: 6,label: '6m',step: 'month',stepmode: 'backward'},
                    {step: 'all'}
                        ]},
                    rangeslider: {autorange: true, visible:true},
                    }
                } else {xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax]};
                }
                
                
                chartLayout = {title: chartTitle, xaxis: xaxisLayout, yaxis: {title:yaxisTitle}, legend: {orientation: 'h',xanchor:"center", y:-1, x:0.5}, showlegend: true};
                
                var chartTraceName = meter.name + " ("+meter.data[0].unit+")";
                
                let chartTraceXArray = [];
                meter.data.forEach((reading)=>{
                    //convert into local browser time from UTC before putting into X array
                    //original utc format in 11/3/2018 03:30:00 PM
                    //let utcDateTime = moment(reading).format('M/D/YYYY hh:MM:SS a');
                    chartTraceXArray.push(moment.utc(reading.utcRectime).local().toDate());
                });
                
                
                let chartTraceYArray = [];
                    meter.data.forEach((reading)=>{
                    chartTraceYArray.push(reading.value);      
                    
                });     
               
               //get the index of this.charts where to put data based on unit
                               
                    
                  //check if unit of meter is in the unit array otherwise add to unit array and push a template graph
                if(unitsArray.includes(chartUnit)== false){
                    unitsArray.push(chartUnit);
                    
                chartUuid = 'chart'+chartCounter.toString();
                    chartCounter++;
                chartsGraphData.push({uuid: chartUuid, traces: [], layout: chartLayout})    
                    
                }
                
               let graphIndex = unitsArray.findIndex(x=>x==chartUnit);    
                      
                
                var chartLineColour = '#17BECF'
                let chartTrace = {type: "scatter", mode: "lines", name: chartTraceName, x: chartTraceXArray, y: chartTraceYArray};
                //line: {color: '#17BECF'}
                
                //push the chart data tract into the graph with the corresponding index
                chartsGraphData[graphIndex].traces.push(chartTrace);

            });
 
            this.charts = chartsGraphData;
            console.log(chartsGraphData);    
             this.loading = false;       
        },
        
        graphSeparateMeterData(){
            this.loading = true;
            //Variation 2 is to split graphs by units
            //empty the charts data field
            var chartsGraphData=[];
            var chartTraces = [];
            var unitsArray = [];
            var chartCounter = 0;
            var chartLayout = {};

            this.meterData.forEach((meter,index)=>{
                let chartUnit = meter.data[0].unit;
              
                
                var chartUuid = 'chart'+index.toString(); //if trying to change div without an existing div then will throw null error for DOM
                
                var chartlayout = {};
                var chartTitle = '';
                var xaxisTitle = '';
                var yaxisTitle = '';
                  var xaxisRangeMin = moment.utc(this.utcStartTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                var xaxisRangeMax = moment.utc(this.utcEndTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                
                 var xaxisLayout;
                if (this.includeRangeSlider === true){
                xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax], rangeselector: {buttons: [
                    { count: 1,label: '1d',step: 'day',stepmode: 'backward'},
                    { count: 7,label: '1w',step: 'day',stepmode: 'backward'},
                    { count: 1,label: '1m',step: 'month',stepmode: 'backward'},
                    { count: 6,label: '6m',step: 'month',stepmode: 'backward'},
                    {step: 'all'}
                        ]},
                    rangeslider: {autorange: true, visible:true},
                    }
                } else {xaxisLayout = {title: xaxisTitle, range: [xaxisRangeMin, xaxisRangeMax]};
                }
                
                
                chartLayout = {title: chartTitle, xaxis: xaxisLayout, yaxis: {title:yaxisTitle}, legend: {orientation: 'h',xanchor:"center", y:1.2, x:0.5}, showlegend: true};

                var chartTraceName = meter.name + " ("+meter.data[0].unit+")";
                
                let chartTraceXArray = [];
                meter.data.forEach((reading)=>{
                    //convert into local browser time from UTC before putting into X array
                    //original utc format in 11/3/2018 03:30:00 PM
                    //let utcDateTime = moment(reading).format('M/D/YYYY hh:MM:SS a');
                    chartTraceXArray.push(moment.utc(reading.utcRectime).local().toDate());
                });
                 
                let chartTraceYArray = [];
                    meter.data.forEach((reading)=>{
                    chartTraceYArray.push(reading.value);      
                    
                });

                var chartLineColour = '#17BECF'
                let chartTrace = {type: "scatter", mode: "lines", name: chartTraceName, x: chartTraceXArray, y: chartTraceYArray};
                //line: {color: '#17BECF'}
                
                
                //push the chart data tract into the graph
            chartsGraphData.push({uuid: chartUuid, traces: [chartTrace], layout: chartLayout})   
            });
 
            this.charts = chartsGraphData;
            console.log(chartsGraphData);  
            this.loading = false;               
        },
        
        //Save all the data in the this.meterData into a CSV
        saveDataAsCSV(){
            this.loading=true;   
            console.log("Time to save meter data to a CSV!");
            
            var csvData =''; 
            let separator = ',';
            let newline = '\n';
            var BOM = "\uFEFF";
            let rowHeaderArray = [];
            let maxlength = 0;
            let step = 0;
            let rowArray = [];
            
            //Get headers
            this.meterData.forEach((meter)=>{
                rowHeaderArray.push("DateTime "+meter.name+ " " + meter.data[0].unit);
                rowHeaderArray.push(meter.name);
                
                // get length of meter with most data
                if(meter.data.length > maxlength){
                    maxlength = meter.data.length;
                }
            });

            let rowHeaders = rowHeaderArray.join(separator)
            csvData += rowHeaders + newline;
            
            //Get rest of data
            for (step = 0; step < maxlength; step++){
            let rowArray = [];
            
            //for each meter
            this.meterData.forEach((meter)=>{
                //if no data, then add a blank
                if(meter.data[step] === undefined){
                    rowArray.push('');
                    rowArray.push('');
                }else{
                //otherwise add data to the row    
                rowArray.push(moment.utc(meter.data[step].utcRectime).local().format("DD/MM/YYYY HH:mm:ss"));
                rowArray.push(Number(meter.data[step].value));    
                }                
            });
            let row = rowArray.join(',');
            csvData += row + newline;
            }
            
        
        //SaveAsFile("\uFEFF" + csvData,"filename.csv","text/csv;charset=utf-8");
           var blob = new Blob([BOM + csvData],  { type: "text/csv;charset=utf-8" });
            saveAs(blob, "csvMeterData.csv");
            this.loading=false;   
            
        
        },
        
        
        

    },
    
        //Mounted Stage
        mounted() {
        //this.loginNavigator();
        this.initialLoad();
        	
            //add mock data to chart
            /*for (let i = 0; i < 100; i++) {
            	this.addData();
            }*/
            
        //this.$axios http get request with username passwor authentication to Navigator API
        //setInterval(() => this.updateDevices(), 5* 60 * 1000)  
    },


          //Created Stage
          created() {
          },
          watch: {
              
              //when selected User dimension changes, then get new tree node/meter root data
              selectedUserDimension: function(val){
                   this.updateMeterTreeRoot();
                },
                selectedTimeRange: function(val){
                    this.setDates(val);
                },
          }
      };
      
      
     

     
  </script>
  
  
  <style scoped>
  
  
      .column.scroll {
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: wrap;
  
      
      }
      
      .level-item {
        flex-shrink: 1;
        padding-right: 10px;
        }
        
      .field.extra-space {
        padding-right: 30px;
        }
        
      .search-result-item {
        font-size:0.8em;
        }
        
      .meter-list-graph-item {
        font-size:0.8em;
        }
       
       .navbar-text {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: -0.4em;
            padding-left: 1em;
        }
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
           padding-top: 4px;
            left: 0;
            text-align: center;
            margin: auto;
        }
       
               
        label.stack{  
            width:200px;       

            display:inline-block;    
            vertical-align:middle; 
        }
            
        .meter-selected{
        color:blue;
        }     

        .node-selected{
        background-color:#0d5a60;
        color:white;
        }
        
           
         .button.is-primary {
       background-color:#000028;
        color:white;
        }       
       
       .button.is-primary:hover{
         background-color:#000028;
           color:white;
       }
       
       .button.is-primary:active{
         background-color:#002949;
           color:white;
       }
       
       
       .section {
  margin-top: -3em;
  padding-top :-3px
}

      .column{
      height:calc(100vh - 50px);
      overflow-y: auto;
      overflow-x: hidden;
       white-space: wrap;
  }   


             
  </style>